import { Backbone } from "extensions/backbone";
import { _ } from "extensions/underscore";

export const PagerModel = Backbone.Model.extend({
    defaults: {
        page: 1,
        total: null,
        limit: 100,
        enabled: true
    },
    resetState() {
        this.set(_.pick(this.defaults, "page", "total", "limit"));
    }
});
